import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faCheckCircle, faUtensils, faPalette } from '@fortawesome/free-solid-svg-icons';
import '../../styles/boat/BoatLeadSuccessModal.css';

const BoatLeadSuccessModal = ({ onClose }) => {
  const coreApp = document.getElementById('core-app');

  if (!coreApp) {
    return null;
  }
  
  return ReactDOM.createPortal(
    <div className="core__modal" onClick={onClose}>
        <div className="core__modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="core__modal-header">
                <h2>Thank You!</h2>
                <button className="core__modal-close" onClick={onClose}>
                    <FontAwesomeIcon icon={faClose} />
                </button>
            </div>
            <div className="core__modal-body">
                <div className="boat-success__icon-wrapper">
                    <FontAwesomeIcon icon={faCheckCircle} className="boat-success__icon" />
                </div>
                <h3 className="boat-success__title">Your request has been sent!</h3>
                <p className="boat-success__text">
                    Our team will contact you shortly to finalize the details of your experience.
                </p>
                
                <div className="boat-success__promo">
                    <h4>While you wait, why not explore our premium services?</h4>
                    <div className="boat-success__promo-options">
                        <Link to="/services" className="promo-option catering" onClick={onClose}>
                            <FontAwesomeIcon icon={faUtensils} className="promo-icon" />
                            <span className="promo-label">Catering Services</span>
                        </Link>
                        <Link to="/services" className="promo-option decorations" onClick={onClose}>
                            <FontAwesomeIcon icon={faPalette} className="promo-icon" />
                            <span className="promo-label">Decoration Packages</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>,
    coreApp
  );
};

export default BoatLeadSuccessModal; 